<template>
<div class="success-submit">
  <div class="success-inner">
    <i class="el-icon-success icon-inner"></i>
    <p class="center-text">{{$t('The_order_was_submitted_successfully_please_wait_for_system_review')}}</p>
    <div class="bot-box">
      <vs-button
        @click="goOnHandle"
        class="left-btn"
        type="border"
      >{{$t('Continue_to_deposit')}}</vs-button>
      <vs-button
        @click="checkOrder"
      >{{$t('check_order')}}</vs-button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {

    }
  },
  methods: {
    goOnHandle() {
      // 浏览器后退
      this.$router.go(-1);
    },
    checkOrder(){
      // 跳去审核记录页面
      this.$router.push({name: 'auditList'});
    }
  },
}
</script>

<style lang="scss" scoped>

.success-inner {
  height: 400px;
  background-color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .center-text {
    color: #5E5873;
    margin: 20px;
    font-size: 16px;
  }
  .icon-inner {
    font-size: 40px;
    color: #41B883;
  }
  .left-btn {
    margin-right: 10px;
  }
}
</style>
